import { TextSnippetOutlined } from "@mui/icons-material"
import { Box, Chip, Typography } from "@mui/material"
import { DataNode } from "graphql/types"
import { useStoreState } from "hooks/storeHooks"
import { useDataNodeChanged } from "hooks/useDataNodeChanged"

type TextBlockInfoCompactProps = {
  dataNode: DataNode
}

export const TextBlockInfoCompact = ({ dataNode }: TextBlockInfoCompactProps) => {
  const { hasDataNodeChanged } = useDataNodeChanged()
  const { textBlocks } = useStoreState((state) => state)

  // Helper function to get textblock name by ID
  const getTextBlockName = (textBlockId: string): string => {
    const textBlock = textBlocks.find((tb) => tb.id === textBlockId)
    return textBlock?.name || "Unbekannter Textblock"
  }

  // Only show if this DataNode comes from a textblock
  if (!dataNode.originalTextblockId || dataNode.originalTextblockId === "") {
    return null
  }

  const hasChanges = hasDataNodeChanged(dataNode)

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      {hasChanges && (
        <Chip
          label="geändert"
          size="small"
          color="warning"
          variant="outlined"
          sx={{ height: 20, fontSize: "0.7rem" }}
        />
      )}

      <TextSnippetOutlined fontSize="small" color={hasChanges ? "warning" : "info"} />
      <Typography variant="body2" color={hasChanges ? "warning.dark" : "info.dark"}>
        Textvorlage: "{getTextBlockName(dataNode.originalTextblockId)}"
      </Typography>
    </Box>
  )
}
